import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import "./style/init_style.css";

const InitPage = () => {
  return (
    <div className="w-full h-screen flex flex-column align-items-center justify-content-center">
      <ProgressSpinner
        strokeWidth="3"
        animationDuration=".5s"
        className='init-loading-spinner'
      />
      {/* <div className="text-white text-xl mt-4 font-semibold">
        Loading your experience...
      </div> */}
    </div>
  );
}

export default InitPage;
